module.exports = __webpack_public_path__ + "static/media/physical_mental_breath.734de4e7.jpg";